import { Directive, forwardRef } from '@angular/core';
import { CheckboxRequiredValidator, NG_VALIDATORS } from '@angular/forms';

/**
 * Validator for checkbox's required attribute in template-driven checkbox.
 * Current RequiredValidator only work with `input type=checkbox` and does not
 * work with `checkbox`.
 */
@Directive({
    selector: `checkbox[required][formControlName], checkbox[required][formControl],
               checkbox[required][ngModel], ratio[required][formControlName],
               ratio[required][formControl], ratio[required][ngModel]`,
    host: { '[attr.required]': 'required ? "" : null' },
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => CheckboxRequiredValidatorDirective),
            multi: true,
        },
    ],
})
export class CheckboxRequiredValidatorDirective extends CheckboxRequiredValidator {}
